<!--
 * @Description: 更多按钮公共组件 -- PC端
 * @Author: 思齐
 * @Date: 2025-07-22 15:35:00
 * @LastEditors: 思齐
 * @LastEditTime: 2025-07-22 15:35:00
-->
<template>
	<div class="more-button" @click="handleClick">
		{{ title }}
		<img :src="arrowRightGrey" alt="" />
	</div>
</template>

<script setup>
import arrowRightGrey from "~/assets/images/arrow-right-grey.png";

const props = defineProps({
	title: {
		type: String,
		default: "更多",
	},
	onClick: {
		type: Function,
		default: () => {},
	},
});

const emit = defineEmits(["click"]);

const handleClick = () => {
	if (props.onClick) {
		props.onClick();
	}
	emit("click");
};
</script>

<style lang="scss" scoped>
.more-button {
	width: 112px;
	height: 32px;
	font-family:
		PingFang SC,
		PingFang SC;
	font-size: 15px;
	text-align: center;
	letter-spacing: 1px;
	background: #ffffff;
	border-radius: 30px;
	border: 1px solid #dddddd;
	color: #2b2f36;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	transition:
		transform 0.2s ease,
		box-shadow 0.2s ease;

	img {
		width: 16px;
		height: 16px;
		margin-left: 4px;
	}

	&:hover {
		transform: scale(1.05);
		box-shadow: 0 8px 18px rgba(43, 47, 54, 0.12);
	}
}
</style>
